export default __webpack_public_path__ + "a4f2b495a11b113c1e1a8bb74e3b03c5.png";